import React from 'react';

import Check from '@sats-group/icons/16/check';
import ArrowRight from '@sats-group/icons/24/arrow-right';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';

import type { Club as Props } from './club.props';

const Club: React.FunctionComponent<Props> = ({
  benefits,
  campaign,
  id,
  link,
  name,
  region,
}) => (
  <a className="club" href={link} data-id={id}>
    <div className="club__left">
      <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
        {name}
      </Text>
      {campaign ? (
        <div className="club__tag">
          <Tag
            size={Tag.sizes.s}
            text={campaign.text}
            variant={Tag.variants.positive}
          />
        </div>
      ) : null}
      {region ? (
        <div className="club__tag">
          <Tag size={Tag.sizes.s} text={region} />
        </div>
      ) : null}
    </div>
    {benefits ? (
      <div className="club__benefits">
        {benefits.map(benefit => (
          <div className="club__benefit" key={benefit}>
            <Text size={Text.sizes.small}>
              <Check />
            </Text>
            <Text size={Text.sizes.small}>{benefit}</Text>
          </div>
        ))}
      </div>
    ) : null}
    <div className="club__icon">
      <ArrowRight />
    </div>
  </a>
);

export default Club;
